import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { authForgot } from "../../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authForgot(email);
    } catch (err) {
      // Deliberately generic to the user (do not reveal whether the email exists),
      // but log for debugging.
      console.error("[forgot-password] request failed", err);
    } finally {
      setBusy(false);
      setDone(true);
    }
  };

  return (
    <div className="min-h-screen bg-brand-black flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white p-8 sm:p-10">
        <h1 className="font-serif text-2xl text-brand-black mb-2">Reset your password</h1>
        {done ? (
          <p className="text-sm text-brand-darkgrey" data-testid="forgot-confirmation">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-brand-darkgrey">Enter your staff email and we will send you a secure reset link.</p>
            <div className="space-y-2">
              <Label className="text-sm font-semibold">Email address</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="forgot-email-input" className="rounded-sm focus-visible:ring-brand-gold" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit-button"
              className="w-full bg-brand-black text-white hover:bg-brand-gold rounded-sm">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <div className="mt-5 text-center">
          <Link to="/admin/login" className="text-sm text-brand-gold hover:text-brand-black" data-testid="forgot-back-link">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
